export default __webpack_public_path__ + "static/media/monolith-ssh.488177d4.gif";